import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type {
  CreateExceptionInput,
  ExceptionListMeta,
  ExceptionReportDto,
  ExceptionListQuery,
  ResolveInput,
} from './types';

/** FR-007: file a difference report on a batch (gate exception.report.create). */
export const createExceptionReport = async (
  batchId: string,
  body: CreateExceptionInput,
): Promise<ExceptionReportDto> => {
  const res = await apiClient.post<ApiSuccess<ExceptionReportDto>>(
    `/monthly-batches/${batchId}/exceptions`,
    body,
  );
  return res.data.data;
};

export const fetchExceptions = async (
  params: ExceptionListQuery = {},
): Promise<{ data: ExceptionReportDto[]; meta: ExceptionListMeta }> => {
  const res = await apiClient.get<ApiSuccess<ExceptionReportDto[], ExceptionListMeta>>(
    '/exceptions',
    { params },
  );
  const data = res.data.data ?? [];
  const meta = res.data.meta ?? {
    total: data.length,
    page: params.page ?? 1,
    per_page: params.per_page ?? data.length,
  };
  return { data, meta };
};

export const fetchExceptionsForBatch = async (batchId: string): Promise<ExceptionReportDto[]> => {
  const res = await apiClient.get<ApiSuccess<ExceptionReportDto[]>>(
    `/monthly-batches/${batchId}/exceptions`,
  );
  return res.data.data;
};

export const resolveException = async (
  exceptionId: string,
  body: ResolveInput,
): Promise<ExceptionReportDto> => {
  const res = await apiClient.post<ApiSuccess<ExceptionReportDto>>(
    `/exceptions/${exceptionId}/resolve`,
    body,
  );
  return res.data.data;
};

export const waiveException = async (
  exceptionId: string,
  body: ResolveInput,
): Promise<ExceptionReportDto> => {
  const res = await apiClient.post<ApiSuccess<ExceptionReportDto>>(
    `/exceptions/${exceptionId}/waive`,
    body,
  );
  return res.data.data;
};
